export const navbarData = [
	{
		text: 'About',
		id: 'about',
		spy: true,
		duration: 500,
		smooth: true,
		exact: 'true',
		offset: -80,
		to: 'about',
	},
	{
		text: 'Programs',
		spy: true,
		duration: 500,
		smooth: true,
		exact: 'true',
		offset: -80,
		to: 'programs',
	},
	{
		text: 'Events',
		spy: true,
		duration: 500,
		smooth: true,
		exact: 'true',
		offset: -80,
		to: 'events',
	},
];
